$(function () {
    $(".testimonials-slider .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            draggable: true,
            prevArrow: thisElement.closest('.testimonials-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.testimonials-slider').find('.sliderNextButton'),
            mobileFirst: true,
        });
    })
});

$(function () {
    $(".product-slider .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            draggable: true,
            prevArrow: thisElement.closest('.product-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.product-slider').find('.sliderNextButton'),
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                        variableWidth: false
                    }
                }
            ]
        });
    })
});

$(function () {
    $(".list-item-slider .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            draggable: true,
            prevArrow: thisElement.closest('.list-item-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.list-item-slider').find('.sliderNextButton'),
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        dots: false,
                        centerMode: false,
                        variableWidth: false,
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        dots: true,
                        centerMode: false,
                        variableWidth: false,
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        dots: true,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false,
                        variableWidth: false
                    }
                }
            ]
        });
    })
});

$(function () {
    $(".list-item-module-slider .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            draggable: true,
            prevArrow: thisElement.closest('.list-item-module').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.list-item-module').find('.sliderNextButton'),
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        centerMode: false,
                        variableWidth: false,
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false,
                        variableWidth: false
                    }
                }
            ]
        });
    })
});

$(function () {
    $(".image-block-slider.__two .slider-items, .image-block-slider.__three .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            dots: true,
            centerMode: false,
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            draggable: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: "unslick"
                },
                {
                    breakpoint: 992,
                    settings: {
                        dots: true,
                        centerMode: false,
                        variableWidth: false,
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    })

    $(".image-block-slider.__one .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            dots: true,
            centerMode: false,
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            draggable: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: "unslick"
                },
            ]
        });
    })
});

$(function () {
    $(".banner-card-slider").each(function () {
        var thisElement = $(this);
        var parentSlider = $(this).closest('.banner-card-wrap');
        var bannerCards = thisElement.find('.banner-card');

        if (bannerCards.length > 1) {
            thisElement.slick({
                fade: true,
                cssEase: 'linear',
                dots: false,
                centerMode: false,
                variableWidth: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplay: true,
                draggable: true,
                prevArrow: thisElement.closest('.banner.__homepage').find('.sliderPrevButton'),
                nextArrow: thisElement.closest('.banner.__homepage').find('.sliderNextButton'),
                mobileFirst: true
            });

            thisElement.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
                var progressBar = parentSlider.find('.progress');
                var progressBarLabel = parentSlider.find('.banner-card-slider__label');

                if (progressBar.length) {
                    progressBar
                        .css('background-size', calc + '% 100%')
                        .attr('aria-valuenow', calc);

                    progressBarLabel.text(calc + '% completed');
                }
            });
        } else {
            // If there's only 1 item, disable autoplay and hide the progress bar
            thisElement.slick({
                fade: true,
                cssEase: 'linear',
                dots: false,
                centerMode: false,
                variableWidth: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplay: false, // Disable autoplay
                draggable: true,
                prevArrow: thisElement.closest('.banner.__homepage').find('.sliderPrevButton'),
                nextArrow: thisElement.closest('.banner.__homepage').find('.sliderNextButton'),
                mobileFirst: true
            });

            parentSlider.find('.slider-controls.__progress').hide(); // Hide the progress bar
        }
    });
});